/**
 * mcycle homepage product list module
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/8
 */
import './index.css';
import React, { Component } from 'react';
import ProductItem from './productItem/productItem';
import Pagination from '../../lib/pagination';
import Empty from './empty/index';

class ProductList extends Component {

  render() {
    const { isHome, query } = this.props;
    const { resultList, totalCount, pageSize, current } = this.props.product;
    const isEmpty = resultList.length === 0;

    return (
      <div className="mcycle-home-product">
        {/* product list */}
        <ul className="mcycle-home-product-list clearfix">
          {
            resultList.map((item, index) => (
              <ProductItem id={item.id} link={ item.imageUrl } name={ item.name } price={ item.price } key={ index } />
            ))
          }
        </ul>
        <div className="mcycle-home-product-page" style={{display: isEmpty ? 'none': 'block'}}>
          <Pagination current={ current } pageSize={ pageSize } total={ totalCount } />
        </div>

        {/* empty product */}
        <Empty isHome={isHome} isEmpty={isEmpty} query={query} />
      </div>
    )
  }
}

export default ProductList


// WEBPACK FOOTER //
// ./src/components/home/productList/index.js